import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as XLSX from "xlsx";
import { UserWalletService } from "../user-wallet.service";
@Component({
  selector: "app-user-transactions",
  templateUrl: "./user-transactions.component.html",
  styleUrls: ["./user-transactions.component.sass"],
})
export class UserTransactionsComponent implements OnInit {
  constructor(
    private userWalletService: UserWalletService,
    public activatedRoute: ActivatedRoute,
    public toaster: ToastrService,
    public spinner: NgxSpinnerService
  ) {}

  id: "";
  name: "";
  phoneNumber: "";
  vehicleType: "";
  walletData: {};
  driverDetails: any;

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.queryParams.id;
    // console.log("Driver Id",this.id)
    this.getBalance();
    this.getTransactionHistory(5);
    this.getUser();
  }

  userData: any;
  getUser() {
    this.spinner.show();
    let Data = {
      id: this.id,
    };
    this.userWalletService.userByID(Data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.userData = result.data;
        console.log("User Data", this.walletData);
      } else {
        this.toaster.error(result.message);
      }
    });
  }

  walletBalance: "";
  getBalance() {
    this.spinner.show();
    let Data = {
      userId: this.id,
    };
    this.userWalletService.userBalance(Data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.walletData = result.data;
        this.walletBalance = result.data.walletBalance;
        console.log("Wallet Data", this.walletData);
      } else {
        this.toaster.error(result.message);
      }
    });
  }

  transactionData: any;
  data: [];
  itemsPerPage: number = 5;
  totalItems: any;
  page: number = 0;
  getTransactionHistory(itemPerPage) {
    this.spinner.show();
    let Data = {
      userId: this.id,
      page: 0,
      perPage: itemPerPage,
    };
    // console.log("Data",Data)
    this.userWalletService
      .getUserWalletTransactions(Data)
      .subscribe((result: any) => {
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.transactionData = result.data;
          this.totalItems = result.totalRecords;
          // console.log("Transaction Data",result)
        } else {
          this.toaster.error(result.message);
        }
      });
  }

  gty(page) {
    this.spinner.show();
    let Data = {
      userId: this.id,
      page: this.page - 1,
      perPage: this.itemsPerPage,
    };
    // console.log("Data",Data)
    this.userWalletService
      .getUserWalletTransactions(Data)
      .subscribe((result: any) => {
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.transactionData = result.data;
          // console.log("Transaction Data",this.transactionData)
        } else {
          this.toaster.error(result.message);
        }
      });
  }

  allTransactionData: any;
  getAllTransactionData() {
    this.spinner.show();
    let Data = {
      userId: this.id,
      page: 0,
      perPage: this.totalItems,
    };
    console.log("Data", Data);
    this.userWalletService
      .getUserWalletTransactions(Data)
      .subscribe((result: any) => {
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.allTransactionData = result.data;
          this.exportAllToExcel(this.allTransactionData);
        } else {
          this.toaster.error(result.message);
        }
      });
  }

  // Export To Excel
  exportTableToExcel(tableId: string, fileName: string): void {
    const tableElement = document.getElementById(tableId);
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(tableElement);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  exportAllToExcel(array) {
    // console.log("Export Excel All Data",array)
    const data = array.map((item) => ({
      UserId: item.userId,
      PackageID: item.packageId,
      Amount: item.amount,
      Type: item.type,
      Reason: item.reason,
      CreatedON: new Date(item.createdOnTS * 1000).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Driver_Transactions.xlsx");
  }
}
